import React, { Component } from 'react';
import styled from 'styled-components';

import FiosFiveIntroComponent from './fios-five-components/FiosFiveIntroComponent';
import FiosFivePickChannelsComponent from './fios-five-components/FiosFivePickChannelsComponent';

import {ChannelsData} from './assets/data/channels'
import FiosFiveExitChannel from './fios-five-components/FiosFiveExitChannel';

const ContentWrapper = styled.div`
    
`;

const manageSelectedChannels = () => {
    const channels = [];

    channels.push(ChannelsData[1]);
    channels.push(ChannelsData[2]);
    channels.push(ChannelsData[4]);
    channels.push(ChannelsData[6]);
    channels.push(ChannelsData[7]);

    return channels;
}


class FiosFiveComponent extends Component {
    static getDerivedStateFromProps(props, state) {
        let temp =  props.flowFor === 'new' ? [] : props.selectedChannels;
        return {
            selectedChannels: temp
        }
    }

    addToPlan = (selectedChannels) => {        
        this.props.close(selectedChannels);
    }

    render() {
        return (
            <ContentWrapper>
                <React.Fragment>
                     {this.props.buildProduct.tv.fiosFive.fiosFiveModal === 'intro' && (<FiosFiveIntroComponent flowFor={this.props.flowFor} dispatch={this.props.dispatch} disclaimerProductsFragments={this.props.buildProduct.disclaimerProductsFragments} buildProduct={this.props.buildProduct} lqState={this.props.lqState}/>)}
                     {this.props.buildProduct.tv.fiosFive.fiosFiveModal === 'pickChannels' && 
                        (<FiosFivePickChannelsComponent 
                            dispatch={this.props.dispatch}
                            channelImgPath={this.props.channelImgPath} 
                            channelsData={this.props.channelsData} 
                            onRemoveChannel={this.props.onRemoveChannel}  
                            selectedChannels={this.state.selectedChannels} 
                            addToPlan={this.addToPlan} 
                            onReview={this.props.changeScreen} 
                            flowFor={this.props.flowFor}
                            onSearchInput={this.props.onSearchInput}
                            searchSuggestions={this.props.searchSuggestions}
                            matchedChannelList={this.props.matchedChannelList}
                            visitId={this.props.visitId}
                            visitorId={this.props.visitorId}
                            lqState={this.props.lqState}
                            packageDetails={this.props.buildProduct.tv.fiosFiveDetailedChannel}
                            vhoParams={this.props.buildProduct.tv.fiosFiveSearchVhoParams}
                            product={this.props.product}
                        />)
                    }
                    {this.props.buildProduct.tv.fiosFive.fiosFiveModal === 'confirmation' && (<FiosFiveExitChannel dispatch={this.props.dispatch}/>)}
                </React.Fragment>
                </ContentWrapper>
            );
    } 

}

export default FiosFiveComponent;